// 通用数据表

export const chartOptions = [
  {
    value: 1,
    label: 'Clicks',
  },
  {
    value: 2,
    label: 'New Registrations',
  },
  {
    value: 3,
    label: 'New Deposit Clients',
  },
  {
    value: 4,
    label: 'New Real Traders',
  },
  {
    value: 5,
    label: 'CPA bonus',
  },
]

export const billingTypes = [
  {
    value: 1,
    label: 'Subsidy',
  },
  {
    value: 2,
    label: 'Deduction',
  },
  {
    value: 3,
    label: 'Withdrawl',
  },
  {
    value: 4,
    label: 'Bonus',
  },
]

export const billingStatus = [
  {
    value: 0,
    label: 'Pending',
  },
  {
    value: 1,
    label: 'Success',
  },
  {
    value: 2,
    label: 'Reject',
  },
]

export const langList = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'th',
    label: 'Thai',
  },
]
